import api from 'core/util/api';
import { CustomDimensionOutgoing } from '@kentik/ui-shared/types/customDimensions.types';
import { UseQueryOptions } from '@tanstack/react-query';

const queryFn = () => api.get('/api/ui/dictionary/customDimensions') as Promise<CustomDimensionOutgoing[]>;

export const customDimensionsQuery = {
  queryKey: ['customDimensionsRaw'] as const,
  queryFn,
  staleTime: 300000
} as const satisfies UseQueryOptions<
  CustomDimensionOutgoing[],
  Error,
  CustomDimensionOutgoing[],
  readonly ['customDimensionsRaw']
>;
